 //eslint-disable-next-line
import config from "@/config";
 
export default config.STYLE